import styles from "../assets/styles/AskStarLoading.module.css";

export default function AskStarError() {
  return (
    <div className={styles.spinner}>
      <div className={styles.circle}>
        <div className={styles.element}></div>
        <div className={styles.element}></div>
        <div className={styles.element}></div>
      </div>

      <div className={styles.warning}>
        이벤트가 종료되었습니다. <br />
        참여해주셔서 감사합니다.
      </div>
    </div>
  );
}
